export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/f421a88e051d022d36bde52c98267d4c.png";